<template>
    <b-field :label="label" label-position="inside" :message="message" :type="message ? 'is-warning' : ''">
        <div v-if="selected" class="entity-select-chosen">
            <div class="entity-select-info">
                <div class="entity-select-name"><i class="far fa-user mr-2"></i>{{selected.last_name}}, {{selected.first_name}}</div>
                <div class="entity-select-meta" v-if="selected.email">{{selected.email}}</div>
            </div>
            <b-button size="is-small" outlined @click="clear"><i class="fal fa-times mr-2"></i>Change</b-button>
        </div>
        <b-autocomplete
            v-else
            v-model="query"
            :data="results"
            :loading="isFetching"
            field="last_name"
            @typing="search"
            @select="select"
            icon="search"
            :placeholder="placeholder">
            <template slot-scope="props">
                <div>
                    <strong>{{props.option.last_name}}, {{props.option.first_name}}</strong>
                    <br>
                    <small>{{props.option.email}}</small>
                </div>
            </template>
            <template slot="empty">{{query && query.length ? 'No customers found.' : 'Type to search...'}}</template>
        </b-autocomplete>
    </b-field>
</template>

<script>
    import debounce from 'debounce';
    import {client as http} from '../http_client';

    export default {
        name: 'UserSelect',
        props: {
            value: {
                type: [Number, String],
                default: null
            },
            label: {
                type: String,
                default: 'Customer'
            },
            placeholder: {
                type: String,
                default: 'Search by name or email...'
            },
            message: {
                type: String,
                default: ''
            }
        },
        data: function () {
            return {
                selected: null,
                query: '',
                results: [],
                isFetching: false
            };
        },
        methods: {
            search: debounce(function (query) {
                if (!query || !query.length) {
                    this.results = [];
                    return;
                }
                this.isFetching = true;
                http.get(`/api/users/search/${encodeURIComponent(query)}/0/20`).then(response => {
                    this.results = response.data.users;
                }).catch(() => {
                    this.results = [];
                }).finally(() => {
                    this.isFetching = false;
                });
            }, 400),
            select(option) {
                if (!option) return;
                this.selected = option;
                this.$emit('input', option.id);
            },
            clear() {
                this.selected = null;
                this.query = '';
                this.results = [];
                this.$emit('input', null);
            },
            loadSelected(id) {
                if (!id) {
                    this.selected = null;
                    return;
                }
                http.get(`/api/users/${id}`).then(response => {
                    this.selected = response.data;
                });
            }
        },
        watch: {
            value(newVal) {
                if (this.selected && this.selected.id == newVal) return;
                this.loadSelected(newVal);
            }
        },
        mounted() {
            this.loadSelected(this.value);
        }
    };
</script>

<style lang="scss" scoped>
    .entity-select-chosen {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 0.5rem;
        border: 1px solid #dbdbdb;
        border-radius: 4px;
        padding: 1.65em 0.75rem 0.5rem;

        .entity-select-info {
            min-width: 0;
        }

        .entity-select-name {
            font-weight: 700;
        }

        .entity-select-meta {
            font-size: .8rem;
            color: #7a7a7a;
        }
    }

    ::v-deep .autocomplete {
        .dropdown-menu {
            width: max-content;
            min-width: 100%;
            max-width: 340px;
        }

        .dropdown-item {
            white-space: normal;
            overflow: visible;
            text-overflow: initial;
        }
    }
</style>
